import React from 'react';
import { clsx } from 'clsx';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MessageOpenIcon } from '../components/icons/MessageOpenIcon';
import deskIcon from '../assets/images/sidebar/desk_icon.png';
import analysisIcon from '../assets/images/common/search-calendar-icon.png';
import settingIcon from '../assets/images/sidebar/settings_icon.png';

interface NavItem {
    labelKey: string;
    icon: string | React.ComponentType<{ className?: string }>;
    href: string;
    beta?: boolean;
}

/** スマホ: 設定の右に配信、その次に分析・デスク */
const navItems: NavItem[] = [
    { labelKey: 'nav.settings', icon: settingIcon, href: '/settings' },
    { labelKey: 'nav.delivery', icon: MessageOpenIcon, href: '/delivery', beta: true },
    { labelKey: 'nav.analysis', icon: analysisIcon, href: '/analysis' },
    { labelKey: 'nav.desk', icon: deskIcon, href: '/desk' },
];

/**
 * モバイル用ボトムナビゲーション
 * @returns
 */
const BottomNav: React.FC = () => {
    /**
     * データ取得
     */

    const { pathname } = useLocation();
    const { t } = useTranslation('sidebar');

    // レンダリング
    return (
        <>
            <nav
                id="bottom-nav"
                className="min-h-24 fixed bottom-0 left-0 w-full bg-kotomilThemaColor shadow-lg z-10 px-1.5 sm:px-3 py-2 bg-opacity-95 rounded-t-xl"
            >
                <div className="flex items-stretch justify-center gap-0.5 sm:gap-1">
                    {navItems.map(({ labelKey, icon: Icon, href, beta }) => (
                        <Link
                            key={href}
                            id={
                                href === '/settings'
                                    ? 'bottom-nav-settings'
                                    : href === '/desk'
                                      ? 'bottom-nav-desk'
                                      : href === '/analysis'
                                        ? 'bottom-nav-analysis'
                                        : href === '/delivery'
                                          ? 'bottom-nav-delivery'
                                          : undefined
                            }
                            to={href}
                            className={clsx(
                                'flex-1 group flex flex-col rounded-lg sm:rounded-xl items-center justify-center gap-0.5 px-0.5 sm:px-1 py-1.5 font-medium hover:bg-white/30 transition min-w-0',
                                pathname === href && 'bg-white/40',
                            )}
                        >
                            {typeof Icon === 'string' ? (
                                <img src={Icon} className="size-7 sm:size-8 shrink-0" alt="" />
                            ) : (
                                <Icon className="size-7 sm:size-8 text-black shrink-0" />
                            )}
                            <span className="flex flex-col items-center gap-0.5 w-full min-w-0 text-center">
                                <span className="text-[10px] sm:text-[11px] font-bold leading-snug whitespace-normal break-words hyphens-auto w-full px-0.5">
                                    {t(labelKey)}
                                </span>
                                {beta ? (
                                    <span className="text-[8px] sm:text-[9px] font-semibold leading-none text-white bg-neutral-800 rounded px-1 py-0.5 border border-white/40 shrink-0">
                                        {t('badges.beta')}
                                    </span>
                                ) : null}
                            </span>
                        </Link>
                    ))}
                </div>
            </nav>
        </>
    );
};

export default BottomNav;
